import { ContactModel, ContactDetailsModel } from "../models/CommonModels";
import { renderNewTextField, renderErrorInfoText } from "./FieldCreators";
import FormItem from '../../components/forms/FormItem';
import * as React from "react";
import { Fieldset, Control, Errors } from "react-redux-form";
import nameof from "../../utils/nameof";
import { localizations } from "../../localization/localization";
import * as validators from '../validators/formValidators'

export const ContactFormGroup = () => {
    return <Fieldset model=".contact">
        <FormItem>
            <Control required validators={{isPhoneNumber: validators.isPhoneNumber}} validateOn={["blur", "change"]} model={`.${nameof<ContactDetailsModel>("phoneNumber")}`} label={localizations.common.phoneNumber} component={renderNewTextField} />
            <Errors model={`.${nameof<ContactDetailsModel>("phoneNumber")}`} show={{touched: true, focus: false}} messages={{isPhoneNumber: localizations.validation.notAPhoneNumber}} wrapper={renderErrorInfoText} />
        </FormItem>
        <FormItem><Control model={`.${nameof<ContactDetailsModel>("phoneDetails")}`} label={localizations.common.phoneNumberDetails} component={renderNewTextField} /></FormItem>
        <FormItem>
            <Control required validators={{isEmail: validators.isEmail}} validateOn={["blur", "change"]} model={`.${nameof<ContactDetailsModel>("email")}`} label={localizations.common.email} component={renderNewTextField} />
            <Errors model={`.${nameof<ContactDetailsModel>("email")}`} show={{touched: true, focus: false}} messages={{isEmail: localizations.validation.notAnEmail}} wrapper={renderErrorInfoText} />
        </FormItem>
        <FormItem><Control model={`.${nameof<ContactDetailsModel>("emailDetails")}`} label={localizations.common.emailDetails} component={renderNewTextField} /></FormItem>
    </Fieldset>
}


// WEBPACK FOOTER //
// ./src/common/forms/ContactFormGroup.tsx